import { useIsLocalDestinationOfferCarouselEnabled } from './useIsLocalDestinationOfferCarouselEnabled'
import { shouldShowLocalDestinationOfferCarousel } from 'home/components/OfferCarousels/localDestinationOfferCarouselModel'

interface Options {
  isHotelFilter: boolean
  regionCode: string
  fetchingDestinations: boolean
  destinationCount: number
}

export function useShowLocalDestinationOfferCarousel(options: Options): boolean {
  const { isHotelFilter, regionCode, fetchingDestinations, destinationCount } = options
  const isEnabled = useIsLocalDestinationOfferCarouselEnabled(regionCode)

  return shouldShowLocalDestinationOfferCarousel({
    isHotelFilter,
    isEnabled,
    fetchingDestinations,
    destinationCount,
  })
}
